// extracted by mini-css-extract-plugin
export default {"container":"Spa_8_container__coW1n"};